import type {
  CampoDaSolicitacaoDeParametros,
  SolicitacaoDeParametros,
  ValorDeParametro
} from './assistente.interface'

export type ValoresDaSolicitacao = Record<string, ValorDeParametro | undefined>

export function camposVisiveisDaSolicitacao (
  solicitacao: SolicitacaoDeParametros,
  valores: ValoresDaSolicitacao
): CampoDaSolicitacaoDeParametros[] {
  const camposPorNome = new Map(solicitacao.campos.map(campo => [campo.nome, campo]))
  return solicitacao.campos.filter(campo => {
    const condicao = campo.visivelQuando
    if (!condicao) return true
    const controlador = camposPorNome.get(condicao.campo)
    if (!controlador) return false
    const valor = valores[controlador.nome] ?? controlador.valorAtual
    return valor === condicao.igualA
  })
}

export function valoresCorrespondemAosCamposVisiveis (
  solicitacao: SolicitacaoDeParametros,
  valores: Record<string, ValorDeParametro>
): boolean {
  const visiveis = camposVisiveisDaSolicitacao(solicitacao, valores)
  const nomesVisiveis = new Set(visiveis.map(campo => campo.nome))
  if (Object.keys(valores).length !== nomesVisiveis.size ||
    Object.keys(valores).some(nome => !nomesVisiveis.has(nome))) return false

  return visiveis.every(campo => {
    const valor = valores[campo.nome]
    if (campo.tipo === 'booleano') return typeof valor === 'boolean'
    if (campo.tipo === 'inteiro') return Number.isInteger(valor)
    return typeof valor === 'string' && (!campo.obrigatorio || Boolean(valor.trim()))
  })
}

export function valoresVisiveisDaSolicitacao (
  solicitacao: SolicitacaoDeParametros,
  valores: ValoresDaSolicitacao
): Record<string, ValorDeParametro> {
  return Object.fromEntries(camposVisiveisDaSolicitacao(solicitacao, valores).flatMap(campo => {
    const valor = valores[campo.nome]
    return valor === undefined ? [] : [[campo.nome, valor]]
  }))
}
